export default __webpack_public_path__ + "static/media/cancel.48efbfc1.svg";